import { CloudXIntegrationDataSchema } from "@redotech/redo-return-core-common/integrations/returns/cloudx/types";
import type { infer as zInfer } from "zod";
import { object } from "zod";

export const getCloudXIntegration = {
  name: "getCloudXIntegration" as const,
  input: object({}),
  output: CloudXIntegrationDataSchema.nullable(),
};

export type CloudXIntegration = zInfer<typeof getCloudXIntegration.output>;
